import { cn } from '../lib/utils';
import { TEST_STATUS, TestStatus } from '../constants/test-status';

const STATUS_LABELS: Record<TestStatus, string> = {
  [TEST_STATUS.COMPLETE]: 'Complete',
  [TEST_STATUS.INCOMPLETE]: 'Incomplete',
  [TEST_STATUS.TIMED_OUT]: 'Timed Out',
};

const STATUS_STYLES: Record<TestStatus, string> = {
  [TEST_STATUS.COMPLETE]: 'text-green-700 bg-green-50',
  [TEST_STATUS.INCOMPLETE]: 'text-amber-700 bg-amber-50',
  [TEST_STATUS.TIMED_OUT]: 'text-red-700 bg-red-50',
};

export function TestStatusBadge({ status }: { status: TestStatus }) {
  return (
    <span
      className={cn(
        'inline-flex items-center w-fit rounded-full border border-transparent px-2.5 py-0.5 text-xs font-semibold',
        STATUS_STYLES[status],
      )}
    >
      {STATUS_LABELS[status]}
    </span>
  );
}
